import { ChangeDetectionStrategy, Component } from '@angular/core';

import { PANE5_TILES } from '../../data/walkthrough.fixtures';

/**
 * Pane 5 / 8 — `Modules` (specs/auth.md §5.4).
 *
 * Copy with a highlighted lead bullet, and EIGHT module tiles with nothing
 * beneath them. Pane 2 draws four tiles and a summary node; the two share the
 * `.vgrid`/`.vmod` atoms and are otherwise different compositions, which is why
 * they are two components rather than one with a `[tiles]` input. Collapsing
 * them would immediately need a second input for the summary, then a third for
 * pane 2's primary outline, and the pane component would have started growing
 * one prop per caller — the shape D31.3 exists to prevent.
 *
 * ⚠ `tile.hotel` reads `Hotel & bookings` here and pane 1's chip reads
 * `Hotel & rooms`: one module, two labels, in one source document (§11 R10).
 * Carried across rather than reconciled — see the fixtures.
 */
@Component({
  selector: 'app-walkthrough-pane5',
  standalone: false,
  templateUrl: './walkthrough-pane5.component.html',
  styleUrls: ['./walkthrough-pane5.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalkthroughPane5Component {
  readonly tiles = PANE5_TILES;
}
